import ApplicationSerializer from 'lumen/serializers/application';

export default class PropertyTagsUserSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'results') {
      return 'property-tags/user';
    }

    return key;
  }
}
